import { render, staticRenderFns } from "./NotificationWorkflowModal.vue?vue&type=template&id=f3140500&scoped=true&"
import script from "./NotificationWorkflowModal.vue?vue&type=script&lang=ts&"
export * from "./NotificationWorkflowModal.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationWorkflowModal.vue?vue&type=style&index=0&id=f3140500&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3140500",
  null
  
)

export default component.exports